import { useEffect, useMemo, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";
import { SkeletonUtils } from "three-stdlib";

export default function TV({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  colliders = "trimesh",
  type = "fixed",
  ...rigidBodyProps
}) {
  const group = useRef();
  const { scene, animations } = useGLTF("/tv.glb");
  const clonedScene = useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    clonedScene.traverse((child) => {
      if (child instanceof THREE.Mesh || child instanceof THREE.SkinnedMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [clonedScene]);

  useEffect(() => {
    if (!actions) return undefined;

    const actionList = Object.values(actions).filter(Boolean);
    actionList.forEach((action) => {
      action.reset().setLoop(THREE.LoopRepeat, Infinity).play();
      action.clampWhenFinished = false;
    });

    return () => {
      actionList.forEach((action) => {
        action.stop();
      });
    };
  }, [actions]);

  return (
    <RigidBody
      type={type}
      colliders={colliders}
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group ref={group} scale={scale}>
        <primitive object={clonedScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/tv.glb");
